<script lang="ts">
  import { getAppConfig } from '../../../common/config/app-config';
  import { getStr } from '../../../common/util';
  import Icon from '../../common/components/Icon.svelte';
  import Text from '../../common/components/Text.svelte';

  export let data: any;
  export let styleCss: string = '';

  $: productIconLabelContents = data?.productIconLabelContents;
  $: warranty = data?.warranty;
  $: skuHasWarranty = warranty?.length > 0 && +warranty > 0;
  $: productExtraLinks = productIconLabelContents?.filter(x => !x.isWarranty || (x.isWarranty && skuHasWarranty)) || [];

  const { encodedContextPath } = getAppConfig();

  let warrantyDuration = data?.warrantyDuration;
  if (warrantyDuration === 'Y') {
    warrantyDuration = getStr('extra.warranty.Year');
  } else if (warrantyDuration === 'M') {
    warrantyDuration = getStr('extra.warranty.Month');
  } else {
    warrantyDuration = getStr('extra.warranty.Day');
  }

  function getContextUrl(url) {
    if (!url) return null;
    if (url.startsWith(encodedContextPath) || url.startsWith('http')) {
      return url;
    }
    return `${encodedContextPath}${url}`;
  }
</script>

{#if data?.isSKUInStock || data?.stock?.stockLevelStatus?.code !== 'outOfStock'}
  {#if productExtraLinks?.length > 0}
    <section class="product_extra_links {styleCss}">
      <ul class="font-weight-normal font-size-sm">
        {#each productExtraLinks as d}
          <li>
            <a class="link" target="_blank" href={getContextUrl(d.lableUrl)} rel="nofollow noopener noreferrer">
              {#if d.iconUrl}
                <Icon glyph={d.iconUrl} type="url" mobileSize={16} desktopSize={27} />
              {/if}
              {#if d.isWarranty}
                <span class="description">
                  <Text key="extra.pdp.arguments.warranty" args={[warranty, warrantyDuration]} />
                </span>
              {:else if d.label}
                <span class="description">{d.label}</span>
              {/if}
            </a>
          </li>
        {/each}
      </ul>
    </section>
  {/if}
{/if}

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .product_extra_links {
    // background-color: $neutral-light-04;
    padding: 16px;
    @include desktop-min-width {
      border-radius: 8px;
      padding: 13.5px 23.5px 24.5px;
    }
    &.mp-external-links {
      padding: 0;
      margin: 0;
      width: 100%;
      background-color: $primary-white;
      display: flex;
      justify-content: center;
    }

    ul {
      display: flex;
      align-items: center;
      padding: 0px;
      margin: 0px;
      justify-content: center;
      list-style: none;
      gap: 17px;
      @include desktop-min-width {
        gap: 28px;
        justify-content: center;
      }

      li {
        position: relative;
        a.link {
          color: $primary-blue;
          text-decoration: none;
          font-weight: 500;
          font-size: 12px;
          line-height: 14px;
          display: flex;
          align-items: center;
          gap: 2px;
          text-decoration: none;

          @include desktop-min-width {
            gap: 10px;
            margin: 5.5px 0;
          }

          .description {
            font-size: 12px;
            line-height: 14px;
            margin: 0px 3px;
            @include desktop-min-width {
              font-size: 14px;
              line-height: 16px;
            }
          }
        }
        a {
          .img-icon {
            padding: 5px 0;
          }
        }
      }
    }
  }
  :global(.sticky-actions) {
    .product_extra_links {
      padding: 0px 16px 8px 0px;
      margin-top: 0;
      width: 100%;
      display: flex;
      justify-content: flex-end;
      ul li a.link {
        gap: 6px;
      }
    }
  }
  :global([dir='rtl'] .sticky-actions) {
    .product_extra_links {
      justify-content: flex-start;
    }
  }
  :global(.sticky-actions .product_extra_links img) {
    width: 16px;
    height: 16px;
  }
</style>
